// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trainer-search-dashboard {
  /* background: rgba(35, 39, 47, 0.4); */
  background: transparent;
  border: none;
  border-radius: 10px;
  padding: 2rem;
  min-height: 80%;
  /* box-shadow: 0 2px 12px #0002; */
  color: #fff;
}

.trainer-search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.trainer-search-controls {
  display: flex;
  gap: 1rem;
}

.trainer-search-input,
.trainer-search-select {
  padding: 0.6rem 1rem;
  border-radius: 6px;
  border: none;
  background: #2c2f36;
  color: #fff;
  font-size: 1rem;
}

.trainer-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.trainer-card {
  background: rgba(26, 29, 35, 0.4);
  border-radius: 10px;
  padding: 1.5rem;
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 1px 6px #0002;
  position: relative;
}

.trainer-avatar {
  background: rgba(79, 209, 197, 0.4);
  color: #222;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.trainer-info {
  flex: 1 1;
  width: 100%;
}

.trainer-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.trainer-specialties {
  margin-bottom: 0.5rem;
}

.trainer-specialty {
  background: rgba(79, 209, 197, 0.4);
  color: #222;
  border-radius: 6px;
  padding: 0.2rem 0.7rem;
  font-size: 0.95em;
  margin-right: 0.4rem;
  margin-bottom: 0.2rem;
  display: inline-block;
}

.trainer-bio {
  font-size: 1rem;
  margin-bottom: 0.7rem;
  color: #cfd8dc;
}

.trainer-meta {
  display: flex;
  gap: 1.2rem;
  font-size: 0.98em;
  color: #aaa;
  margin-bottom: 0.7rem;
}

.trainer-contact-btn {
  align-self: flex-end;
  background: #4fd1c5;
  color: #222;
  border: none;
  border-radius: 8px;
  padding: 0.6rem 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.5rem;
}

.trainer-contact-btn:hover {
  background: #38b2ac;
}

.no-trainers {
  color: #aaa;
  font-size: 1.1rem;
  padding: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/TrainerSearch.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf","sourcesContent":[".trainer-search-dashboard {\n  /* background: rgba(35, 39, 47, 0.4); */\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  padding: 2rem;\n  min-height: 80%;\n  /* box-shadow: 0 2px 12px #0002; */\n  color: #fff;\n}\n\n.trainer-search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.trainer-search-controls {\n  display: flex;\n  gap: 1rem;\n}\n\n.trainer-search-input,\n.trainer-search-select {\n  padding: 0.6rem 1rem;\n  border-radius: 6px;\n  border: none;\n  background: #2c2f36;\n  color: #fff;\n  font-size: 1rem;\n}\n\n.trainer-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.trainer-card {\n  background: rgba(26, 29, 35, 0.4);\n  border-radius: 10px;\n  padding: 1.5rem;\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: 0 1px 6px #0002;\n  position: relative;\n}\n\n.trainer-avatar {\n  background: rgba(79, 209, 197, 0.4);\n  color: #222;\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.trainer-info {\n  flex: 1;\n  width: 100%;\n}\n\n.trainer-name {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 0.3rem;\n}\n\n.trainer-specialties {\n  margin-bottom: 0.5rem;\n}\n\n.trainer-specialty {\n  background: rgba(79, 209, 197, 0.4);\n  color: #222;\n  border-radius: 6px;\n  padding: 0.2rem 0.7rem;\n  font-size: 0.95em;\n  margin-right: 0.4rem;\n  margin-bottom: 0.2rem;\n  display: inline-block;\n}\n\n.trainer-bio {\n  font-size: 1rem;\n  margin-bottom: 0.7rem;\n  color: #cfd8dc;\n}\n\n.trainer-meta {\n  display: flex;\n  gap: 1.2rem;\n  font-size: 0.98em;\n  color: #aaa;\n  margin-bottom: 0.7rem;\n}\n\n.trainer-contact-btn {\n  align-self: flex-end;\n  background: #4fd1c5;\n  color: #222;\n  border: none;\n  border-radius: 8px;\n  padding: 0.6rem 1.2rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.5rem;\n}\n\n.trainer-contact-btn:hover {\n  background: #38b2ac;\n}\n\n.no-trainers {\n  color: #aaa;\n  font-size: 1.1rem;\n  padding: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
